export const seoTitle = 'LNG服务 | 产品服务 | 赑玄阁';
export const seoDescription = 'LNG服务为液化天然气行业提供中短期全球气温变化预测，其中短期预报包含输气管道积雪、线路结冰和闪电预报，而长期预报将融合业界最先进的模型，从全球多种模型来源获得集合和确定的预测结果， 确保专业性、前瞻性、与行业的融合度，提供最为准确的全球长期气温预报。';
export const browserTitle = 'LNG服务 | 产品服务 | 赑玄阁';
export const keywords = '天然气, LNG服务, 气温变化, 气温变化预测, 全球气温变化,';


export const purposeData = [
  {
    imagePath: require('../../images/products/lng/05.png').default,
    title: '保障天然气管网高效平稳运行',
    titleEn: 'Ensure efficient and smooth operation of natural gas pipeline network',
    subTitle: '分析天然气用气量与温度的关系,为天然气的短期预测提供信息,有利于天然气的调度管理。',
    subTitleEn: 'Analysis of the relationship between natural gas' +
      ' consumption and temperature provides information for' +
      ' short-term forecasting of natural gas and facilitates' +
      ' the management of natural gas dispatch.'
  },
  {
    imagePath: require('../../images/products/lng/06.png').default,
    title: '未来范围内天然气业务变化趋势和成因进行预测及分析',
    titleEn: 'Forecasting and analysis of trends and causes of changes in the natural gas business in the future',
    subTitle: '为能够准确确定某区域天然气消费量的预测模型，跟踪并理解近年来全球主要地区及中国重点业务开展城市气温变化情况，建立气温中短期气温预测模型和分析机制。',
    subTitleEn: 'In order to be able to accurately determine the forecast model for natural gas consumption in a region, we track and understand the temperature changes in recent years in major global regions and key Chinese cities where business is conducted, and establish a model and analysis mechanism for short- and medium-term temperature forecasting.'
  },
  {
    imagePath: require('../../images/products/lng/07.png').default,
    title: '量化实际的气候风险',
    titleEn: 'Quantifying the actual climate risk',
    subTitle: '纳入模型气候风险对其投资组合的过程中加以参考判断，使因为被气候变化而影响的投资组合，可以有效的针对实况以及在近期、中期或长期的未来做出更有利有依据的判断。',
    subTitleEn: 'By incorporating climate risk into the modeling process to inform the judgment of its portfolio, the portfolio affected by climate change can effectively make more favorable judgments about actual conditions and the near, medium, or long-term future.'
  },
];

export const guaranteeData = [
  {
    imagePath: require('../../images/products/lng/11.png').default,
    title: '我们致力打造快速、灵活、 准确的气象系统服务。',
    titleEn: 'We are committed to creating fast, flexible and accurate weather system services',
    subTitle: '对公司和气象学家来说，该系统作为沟通的平台，数据访问的速度和相关信息呈现方式是至关重要的。',
    subTitleEn: 'For company and the meteorologists, the system serves as a platform for communication, and the speed of data access and presentation of relevant information is critica.'
  },
  {
    imagePath: require('../../images/products/lng/12.png').default,
    title: '我们确保数据的传输质量 及传输速度',
    titleEn: 'We ensure the quality and speed of data transmission',
    subTitle: '通过国内建立数据中心以确保数据的传输质量及传输速度,我们提供详细可定制的服务。确保我们的工具能为公司提供优势。',
    subTitleEn: 'By establishing a data center in China to ensure the quality and speed of data transmission, we provide a detailed and customizable service. We ensure that our tools provide an advantage to company.'
  },
  {
    imagePath: require('../../images/products/lng/13.png').default,
    title: '我们保证7/24小时全天候的分析及监测、预测更新和系统支持以及灵活的交互方式及格式',
    titleEn: 'We guarantee 24/7 access to analysis and monitoring, predictive updates and system support, as well as flexible interaction methods and formats',
    subTitle: '通过城市级别的系统运行和安全保障流程，确保稳定及防护。通过即时信息服务与我们的气象学团队保持定期联系。',
    subTitleEn: 'Ensure stability and protection through city-level system operation and security processes. Maintain regular contact with our meteorology team through instant messaging services.'
  },
];

export const forecastData = [
  {
    imagePath: require('../../images/products/lng/26.png').default,
    title: '短期数值预报',
    titleEn: 'Short-term numerical forecasts',
    subTitle: '短期数值预报的10天单级预测大气模型是天气预报中分辨率最高的模型，该模型结合观测数据和地球系统前期气象要素信息，预测未来10-15天的气象信息。该模型每天提供4次预报（00/06/12/18时），这4次预报包含每个小时的天气要素预报，总时长为90小时 ',
    subTitleEn: 'The 10-day single-stage predictive atmospheric model for short-term numerical forecasting is the highest resolution model for weather forecasting, which combines observational data and information from the Earth system’s prior meteorological elements to predict weather information for the next 10-15 days. The model provides four forecasts per day (00/06/12/18 hours), which contain forecasts of weather elements for each hour for a total of 90 hours ',
    subTitle2: '时间范围：未来10-15天，每天00:00 ',
    subTitleEn2: 'Time frame: next 10-15 days, every day 00:00'
  },
  {
    imagePath: require('../../images/products/lng/27.png').default,
    title: '超长期数值预报',
    titleEn: 'Ultra-long-term numerical forecasting',
    subTitle: '超长期预报提供了关于预期未来大气和海洋状况的信息，与中期预报一样，超长期预报也采用海洋-大气耦合模式。长期预测依赖于地球系统变化的各个方面，具有很长的时间尺度(由月到年)，并且在某种程度上是可预测的。超长期预报频次为每个月一次，并在未来延续10个月，提供未来10个月的预报。',
    subTitleEn: 'Ultra-long-range forecasts provide information on expected future atmospheric and oceanic conditions and, like medium-range forecasts, use coupled ocean-atmosphere models. Long-term forecasts rely on various aspects of Earth system changes, have long time scales (from months to years), and are somewhat predictable. The frequency of ultra-long-range forecasts is once per month and extends for 10 months into the future, providing forecasts for the next 10 months.',
    subTitle2: '时间范围：未来1-10月，每月8日12:00',
    subTitleEn2: 'Time frame: January-October, 12:00 on the 8th of each month'
  },
];
